import React from 'react'
import { SelectInput, SelectInputProps, Validator } from 'react-admin'

// This component exists for the sole purpose of removing a redundant default behavior
// of the standard select input: even when the input is not resettable, it allows the section of
// an empty string as a way to clear the field. Guess what? Fields that are not resettable should not be cleared.

// Here are some reasons of why that happens
// https://github.com/marmelab/react-admin/issues/7632

// The only choice available was using a custom validator that always returns a truthy value and clears the empty value.
// This won't collide in any way with our yup validators.

// Now the empty string option is only selectable while the "resettable" prop is passed to the component.

function removeEmptyValue(): Validator & { isRequired: boolean } {
  return Object.assign(() => null, { isRequired: true })
}

const KSelectInput: React.FC<SelectInputProps> = ({ resettable, ...props }) => {
  return (
    <SelectInput
      resettable={resettable}
      validate={resettable ? undefined : removeEmptyValue()}
      {...props}
    />
  )
}

export default KSelectInput
